import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import {
  fetchUserListing,
  fetchUserConversations,
  setSelectedUserId,
} from 'src/redux/chatbotConversations'
import { formatDate, useDebouncedFilter } from './helpers'

const UserTable = () => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const { users, usersLoading, selectedUserId } = useSelector(state => state.chatbotConversations)

  const { filterValue: emailFilter, handleFilterChange: handleEmailFilterChange } =
    useDebouncedFilter(value => {
      dispatch(fetchUserListing({ userEmail: value || undefined }))
    })

  const handleRowClick = userId => {
    dispatch(setSelectedUserId(userId))
    dispatch(fetchUserConversations(userId))
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ p: 2, borderBottom: `1px solid ${theme.palette.grey[200]}`, flexShrink: 0 }}>
        <TextField
          label='Filter by email'
          value={emailFilter}
          onChange={handleEmailFilterChange}
          size='small'
          fullWidth
        />
      </Box>

      {usersLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
          <CircularProgress size={32} />
        </Box>
      ) : (
        <Box sx={{ flex: 1, overflowY: 'auto' }}>
          <Table size='small' stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>User Email</TableCell>
                <TableCell align='right'>Conversations</TableCell>
                <TableCell align='right'>Messages</TableCell>
                <TableCell align='right'>Feedback</TableCell>
                <TableCell>Last Active</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map(user => (
                <TableRow
                  key={user.userId}
                  hover
                  onClick={() => handleRowClick(user.userId)}
                  selected={user.userId === selectedUserId}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell>{user.userEmail}</TableCell>
                  <TableCell align='right'>{user.conversationCount}</TableCell>
                  <TableCell align='right'>{user.totalMessageCount}</TableCell>
                  <TableCell align='right'>{user.totalFeedbackCount}</TableCell>
                  <TableCell>
                    <Typography variant='caption' noWrap>
                      {formatDate(user.lastActiveAt)}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
              {users.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} align='center'>
                    <Typography variant='body2' color='textSecondary'>
                      No users found
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      )}
    </Box>
  )
}

export default UserTable
